import KeyDetail from "src/components/@analytics/key-detail";
import Keytakeaway from "../../../../../../components/reusable/keytakeaways";

const ExaminerTrendKeytakeaways = () => {
  return (
    <KeyDetail section="Key Takeaway">
      <Keytakeaway title={"Reduction in Average Examination Time"} description="N/A" />
      <Keytakeaway title={"Year with Shortest Examination Time"} description="N/A" />
      <Keytakeaway title={"Trend of Decreasing Examination Times"} description="N/A" />
      <Keytakeaway title={"Comparison of Examination Times Across Decades"} description="N/A" />
    </KeyDetail>
  );
};

export default ExaminerTrendKeytakeaways;
